import { Component, Input } from '@angular/core';
import { environment } from '../../services/util.service';

declare type Theme = 'dark' | 'light';
declare type Size = 'small' | 'medium' | 'large' | 'x-large';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() public renderText: boolean;
  @Input() public theme: Theme;
  @Input() public size: Size;
  public brand: string;

  constructor() {
    this.renderText = true;
    this.theme = 'dark';
    this.size = 'large';
    this.brand = environment.brand.toLowerCase();
  }

}